import EmbedCallForImpactCarousel from './container';

export default EmbedCallForImpactCarousel;



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/Carousel/index.js